import { jsPDF } from 'jspdf';
import { saveBlobDownload } from '../../shared/utils/saveBlobDownload';

/**
 * Delivers a generated PDF to the user under `filename`.
 *
 * Delegates to `saveBlobDownload`, which uses Web Share or a short-lived HTTPS
 * storage URL inside native WebViews so the file keeps its name instead of
 * landing as a random blob UUID.
 */
export const savePdfDocument = async (doc: jsPDF, filename: string): Promise<void> => {
  const blob = doc.output('blob');
  await saveBlobDownload(blob, filename, 'application/pdf');
};
